import axios from '@/services/axios';

// Minimal, unpaginated catalog. A failed request is never an empty catalog.
export async function loadOperationalAccounts(fluxo) {
  const { data } = await axios.get('/financeiro/contas-financeiras/selecao-operacional', { params: { fluxo } });
  if (!Array.isArray(data)) throw new Error('Resposta inválida do catálogo de contas.');
  return data.map(account => ({
    id: Number(account.id), apelido: account.apelido,
    conta_padrao: account.conta_padrao === true || account.conta_padrao === 1,
    boletos_habilitados: account.boletos_habilitados === true,
    texto: account.apelido
  }));
}

export const emptyAccountsMessage = 'Nenhuma conta disponível para recebimento nesta escola.';
export function accountSelectionError(error) {
  return error.response?.status === 403
    ? 'Você não possui permissão para selecionar contas nesta operação.'
    : 'Não foi possível carregar as contas. Reabra o formulário para tentar novamente.';
}
